import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2
} from '@angular/core';
import {
  NavigationEnd,
  NavigationError,
  RouteConfigLoadStart,
  Router,
  RouterOutlet
} from '@angular/router';
import {
  TitleService,
  VERSION as VERSION_ALAIN,
  stepPreloader
} from '@delon/theme';
import { environment } from '@env/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { VERSION as VERSION_ZORRO } from 'ng-zorro-antd/version';

import { isAnonymousPage } from './core/net/custom-jwt.interceptor';
import { DropdownService } from './core/util/dropdown.service';
import { AppService } from './shared/services/app.service';
import { ImportSampleDownloadService } from './shared/services/import-sample-download.service';
import { IntegratorTemplateDownloadService } from './shared/services/integrator-template-download.service';

declare global {
  interface Window {
    app: any;
  }
}

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.less'],
  template: ` <router-outlet></router-outlet> `,
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private readonly donePreloader = stepPreloader();
  constructor(
    el: ElementRef,
    renderer: Renderer2,
    private readonly router: Router,
    private readonly titleSrv: TitleService,
    private readonly modalSrv: NzModalService,
    private readonly msg: NzMessageService,
    private readonly appSrv: AppService,
    private readonly dropdownService: DropdownService,
    private readonly importSampleDownload: ImportSampleDownloadService,
    private readonly integratorTemplateDownload: IntegratorTemplateDownloadService
  ) {
    renderer.setAttribute(
      el.nativeElement,
      'ng-alain-version',
      VERSION_ALAIN.full
    );
    renderer.setAttribute(
      el.nativeElement,
      'ng-zorro-version',
      VERSION_ZORRO.full
    );

    // refer to WI 13702, disable drag and drop form value to other fields
    if (document?.body?.addEventListener)
      document.body.addEventListener('drop', event => event.preventDefault());
  }

  ngOnInit(): void {
    this.importSampleDownload.start();
    this.integratorTemplateDownload.start();
    let configLoad = false;
    this.router.events.subscribe(ev => {
      if (ev instanceof RouteConfigLoadStart) {
        configLoad = true;
      }
      if (configLoad && ev instanceof NavigationError) {
        console.error('NavigationError', ev.url, ev.error);
        configLoad = false;
        if (environment.production) {
          this.msg.info(
            `An updated version of the app may have been released. Reloading the app now.`
          );
          this.appSrv.muteLeaveAppAlert();
          window.location.reload();
        } else {
          this.msg.error(`Failed to load route: ${ev.url}`);
        }
      }
      if (ev instanceof NavigationEnd) {
        configLoad = false;
        this.donePreloader();
        this.titleSrv.setTitle();
        this.modalSrv.closeAll();
      }
    });

    this.appSrv.startVersionCheck();
  }

  @HostListener('window:beforeunload', ['$event'])
  canDeactivate(event?: BeforeUnloadEvent) {
    if (window.app && window.app.forcereload) {
      event?.stopImmediatePropagation();
      return;
    }

    const url = window.location.href;

    if (url.indexOf('passport/') > 0) return true;
    if (isAnonymousPage(url)) return true;

    return false;
    // return confirm(
    //   'You are closing QNE AI Cloud Accounting! Please make sure all of your changes has been saved properly before you leave.'
    // );
  }
}
